var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.441406,
    width: 32.4804,
    height: 32.4804,
    rx: 10,
    fill: "#FF704B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_457_222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6103 7.87285C25.7343 8.49077 24.7644 8.96339 23.7379 9.27249C23.1869 8.639 22.4547 8.19 21.6403 7.98621C20.8258 7.78243 19.9684 7.83369 19.1841 8.13306C18.3997 8.43244 17.7262 8.96548 17.2547 9.66011C16.7831 10.3547 16.5363 11.1774 16.5475 12.0169V12.9317C14.9399 12.9734 13.3469 12.6168 11.9104 11.8938C10.4739 11.1708 9.23858 10.1037 8.31434 8.78765C8.31434 8.78765 4.65514 17.0208 12.8883 20.68C11.0043 21.9589 8.75999 22.6001 6.48474 22.5096C14.7179 27.0836 24.7807 22.5096 24.7807 11.9894C24.7799 11.7346 24.7554 11.4804 24.7075 11.2302C25.6412 10.3094 26.3001 9.1469 26.6103 7.87285Z",
    stroke: "white",
    strokeWidth: 1.01217,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_457_222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9552,
    height: 21.9552,
    fill: "white",
    transform: "translate(5.56995 5.12848)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.8c46206a583b991daa660ee2dc1608d0.svg";
export { ForwardRef as ReactComponent };